import { Element } from '@angular/compiler';
import { Component, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Route, Router } from '@angular/router';
import { NgbModal, NgbModalConfig, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AuthService } from '../../core/auth/auth.service';
import { PaymentService } from '../../core/auth/payment.service';

@Component({
    selector: 'app-payment-modal-frozen',
    templateUrl: './payment-modal-frozen.component.html',
    styleUrls: ['./payment-modal-frozen.component.scss'],
    providers: [NgbModalConfig, NgbModal],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class PaymentModalFrozenComponent implements OnInit, OnDestroy {

  @ViewChild('content', { static: true }) content: TemplateRef<any>;
  $modalOpenSubscription = new Subscription();
  openedModal: NgbModalRef;

  constructor(
    config: NgbModalConfig,
    private modalService: NgbModal,
    public paymentService: PaymentService,
    private authService: AuthService,
    private router: Router
  ) {
    // customize default values of modals used by this component tree
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit() {
    this.$modalOpenSubscription.add(this.paymentService.$openPaymentFreezeModalHandler.subscribe(() => {
      this.openedModal = this.open();
    }));
  }

  open(): NgbModalRef {
    return this.modalService.open(this.content, {
      centered: true,
      backdropClass: 'payment-freeze-backdrop',
      windowClass: 'payment-freeze-modal'
    });
  }

  close() {
    this.openedModal.close();
  }

  redirectToPayment(redirectToPayment: boolean = true) {
    if (redirectToPayment) {
      this.router.navigate(['/signup/payment']);
      localStorage.setItem('redirectUrl', this.router.url);
      this.close();
    } else {
      this.authService.logout();
    }
  }

  ngOnDestroy() {
    if (this.$modalOpenSubscription) {
      this.$modalOpenSubscription.unsubscribe();
    }
  }
}
